import { graphql } from 'gatsby';

export const externalCtaFragment = graphql`
  fragment externalCta on PRISMIC_External_cta {
    __typename
    title
    background_color
    link {
      ...linkable
    }
  }
`;
